import {Component, OnInit, OnDestroy} from "@angular/core";
import {BusinessService} from "../../services/data/business.service";
import {ActivatedRoute} from "@angular/router";
import {FamilyAlbum} from "../../model/family-album";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Business} from "../../model/business";
import {Subscription} from "rxjs";
import {UrlService} from "../../services/url.service";

declare const $:any;

@Component({
  selector: 'qr-code',
  template: require('./qr-code.component.html'),
  styles: [
    require('./qr-code.component.scss')
  ]
})

export class QrCodeComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
  }

  event:FamilyAlbum = new FamilyAlbum();

  business: Business;

  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }

  constructor(private businessService:BusinessService, private urlService: UrlService,
              private activatedRoute:ActivatedRoute, private currentBusiness: CurrentBusinessService) {

    this.business = this.currentBusiness.getBusiness();

    $('nav-bar').remove();

    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param:any) => {
        let eventId = param['eventId'];

        this.businessService.getEvent(eventId).subscribe(event => {
          this.eventLoaded(event)
        });
      }
    );

  }

  eventLoaded(event:FamilyAlbum) {
    this.event = event;
    let deepLink = this.urlService.getEventDeepLinkUrl(event.invitationCode);

    $('.code').empty().qrcode({
      'size': 250,
      'text': deepLink,
      ecLevel: 'H',
      minversion: 6,
      radius: 0.30
    });

    setTimeout(function () {
      window.print();
    }, 100);

  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/qrcode/qr-code.component.ts